
/**
 * @nullable
 */
export type CreateCourseDraftBodyLevel = typeof CreateCourseDraftBodyLevel[keyof typeof CreateCourseDraftBodyLevel] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateCourseDraftBodyLevel = {
  BEGINNER: 'BEGINNER',
  INTERMEDIATE: 'INTERMEDIATE',
  ADVANCED: 'ADVANCED',
  ALL: 'ALL',
} as const;
